import { createSelector } from 'reselect';

export const bookLinksSelector = (state) => state.bookLinks;
export const linksSelector = createSelector(bookLinksSelector, (bookLinks) => bookLinks.links);
